<template>
	<div class="modal-container ModalAddEditRebate">
		<div class="modal-header">
			<div>
				Rebate Details
				<div class="additional-info">
					<span v-if="$global.isAdminView && rebate">(Title ID: {{ rebate.titleId ?? 'N/A' }}, Original: {{ bucket.originalTitleId ?? 'N/A' }})</span>
				</div>
			</div>

			<EditInfo
				v-if="!isNewRebate"
				:editableObject="rebate"
			/>
		</div>
		<div class="modal-body">
			<fieldset
				:disabled="modal.isModalDisabled"
				class="no-margin-grid"
				:style="$grid('1')"
			>
				<Panel title="Basic Info">
					<template v-slot:HeaderComponent>
						<div class="panel-buttons">
							<InputRichDropdown
								v-if="isNewRebate"
								v-model:saturn="selectedStoreRebate"
								:list="storeRebates"
								:valueMap="(pf: StoreRebate) => pf"
								:display="(pf: StoreRebate) => (pf.name ? pf.name : 'CUSTOM REBATE')"
								@change="onStoreRebateSelected"
								nothingSelected="-- REBATE Type --"
							>
							</InputRichDropdown>
						</div>
					</template>

					<div :style="$grid('1-1')">
						<!-- <InputTextbox
                            label="Name"
                            v-model:saturn="rebate.desc"
                            placeholder="Rebate Name"
                            :isUpperCase="true"
                            :invalid="v$.rebate.desc.$invalid"
                            :disabled="!rebate.isEditableName || (isNewRebate && !selectedStoreRebate) || (modal.isDealLocked && rebate.itemized)"
                        > FIXME: What is editable name -->
						<InputTextbox
							label="Name"
							v-model:saturn="rebate.desc"
							placeholder="Rebate (Enter Description Here)"
							:isUpperCase="true"
							:invalid="v$.rebate.desc.$invalid"
							:disabled="(isNewRebate && !selectedStoreRebate) || (modal.isDealLocked && rebate.itemized)"
						>
							<template #validation>
								<div v-if="v$.rebate.desc.required.$invalid">Name is required</div>
								<div v-if="v$.rebate.desc.uniqueName.$invalid">Name must be unique</div>
							</template>
						</InputTextbox>
						<InputTextbox
							label="Code"
							v-model:saturn="rebate.code"
							placeholder="Rebate Code"
							:isUpperCase="true"
							:invalid="v$.rebate.code.$invalid"
							:disabled="!rebate.isEditableCode || (isNewRebate && !selectedStoreRebate) || (modal.isDealLocked && rebate.itemized)"
						>
							<template #validation>
								<div v-if="v$.rebate.code.required.$invalid">Code is required</div>
							</template>
						</InputTextbox>

						<InputCurrency
							v-if="rebate.matchToFirstPayment"
							label="Max First Payment Match amount"
							placeholder="Amount"
							v-model:saturn="rebate.maxAmount"
							:precision="2"
							:invalid="v$.rebate.maxAmount.$invalid"
							:disabled="(isNewRebate && !selectedStoreRebate) || modal.isDealLocked"
						>
							<template #validation>
								<div v-if="v$.rebate.maxAmount.required.$invalid">Max amount is required</div>
							</template>
						</InputCurrency>
						<InputCurrency
							v-else
							label="Amount"
							placeholder="Amount"
							v-model:saturn="rebate.amount"
							:precision="2"
							:invalid="v$.rebate.amount.$invalid"
							:disabled="!rebate.isEditableAmount || (isNewRebate && !selectedStoreRebate) || modal.isDealLocked"
						>
							<template #validation>
								<div v-if="v$.rebate.amount.required.$invalid">Amount is required</div>
							</template>
						</InputCurrency>
						<InputCurrency
							label="Cost"
							placeholder="Cost"
							v-model:saturn="rebate.cost"
							:precision="2"
							:invalid="v$.rebate.cost.$invalid"
							:disabled="!rebate.isEditableCost || (isNewRebate && !selectedStoreRebate)"
						>
							<template #validation>
								<div v-if="v$.rebate.cost.required.$invalid">Cost is required</div>
							</template>
						</InputCurrency>
					</div>
					<div
						:style="$grid('1-1')"
						class="no-margin-grid"
					>
						<!-- <InputRichDropdown
                            label="Profit Flag"
                            v-model:saturn="rebate.profitFlag"
                            :list="profitFlags"
                            :valueMap="pf => pf.value"
                            :display="pf => pf.text"
                            nothingSelected="-- Select Value --"
                            :invalid="v$.rebate.profitFlag.$invalid"
                            :disabled="!rebate.isEditableProfitFlag || (isNewRebate && !selectedStoreRebate) || modal.isDealLocked"
                        > -->
						<InputRichDropdown
							label="Profit Flag"
							v-model:saturn="rebate.profitFlag"
							:list="profitFlags"
							:valueMap="(pf: any) => pf.value"
							:display="(pf: any) => pf.text"
							nothingSelected="-- Select Value --"
							:invalid="v$.rebate.profitFlag.$invalid"
							:disabled="(isNewRebate && !selectedStoreRebate) || modal.isDealLocked"
						>
							<template #validation>
								<div v-if="v$.rebate.profitFlag.required.$invalid">Profit Flag To is required</div>
							</template>
						</InputRichDropdown>

						<InputRichDropdown
							v-if="!isNewRebate || selectedStoreRebate"
							label="Itemized on Buyer's Order"
							class="itemized"
							v-model:saturn="rebate.itemized"
							:list="ITEMIZED_OPTIONS"
							:valueMap="(o: any) => o.value"
							:display="(o: any) => o.display"
							:disabled="!rebate.isEditableItemized || (rebate.isEditableItemized && modal.isDealLocked)"
						>
						</InputRichDropdown>
					</div>
				</Panel>
				<Panel title="Tax Lines to Apply">
					<fieldset
						class="no-margin-grid"
						:style="$grid('1')"
						:disabled="modal.isDealLocked"
					>
						<div
							class="no-margin-grid"
							:style="$grid('5-1')"
							v-for="(taxLine, taxLineIndex) in bo.taxGroups"
							:key="taxLine.name"
						>
							<InputCheckbox
								:modelValue="isInThisTaxLine(taxLineIndex)"
								@click="toggleTaxLine(taxLineIndex)"
								class="panel-header-collapse-button description"
								:label="taxLine.name"
							></InputCheckbox>

							<div class="amt">
								<InputNumber
									v-model:saturn="taxLine.rate"
									placeholder="Tax Rate"
									:precision="2"
									:isPercent="true"
									:disabled="true"
								>
								</InputNumber>
							</div>
						</div>
					</fieldset>
				</Panel>
			</fieldset>
		</div>
		<div class="modal-footer modal-footer-split">
			<div>
				<button
					v-if="!isNewRebate"
					class="button-unwind"
					@click="deleteRebate()"
					:disabled="modal.isDealLocked && Boolean(rebate.amount || rebate.itemized)"
				>
					Delete Rebate
				</button>
			</div>
			<div>
				<button
					class="button-unwind"
					@click="cancel()"
				>
					Cancel
				</button>
				<button
					class="button-save"
					@click="close()"
					:disabled="modal.isModalDisabled || v$.$invalid || (modal.isDealLocked && rebate.itemized && rebate.isEditableItemized)"
				>
					Save
				</button>
			</div>
		</div>
	</div>
</template>
<script lang="ts">
	export interface IRebatesBucketModalProps extends IBucketModalProps {
		storeRebates: StoreRebate[];
	}
</script>
<script setup lang="ts">
	import { computed, ref, watch } from 'vue';
	import $modal from '@core/services/modal';
	import auth from '@core/services/auth';
	import DropdownHelper from '@core/helpers/dropdown-helper';
	import { useVuelidate } from '@vuelidate/core';
	import util from '@core/services/util';

	import DealRebate from '@core/classes/Deal/DealRebate';
	import FIMenuBuyersOrder from '@core/classes/FIMenuBuyersOrder';
	import FIMenuBuyersOrderBucket from '@core/classes/FIMenuBuyersOrderBucket';
	import FIMenuBuyersOrderBucketItem from '@core/classes/FIMenuBuyersOrderBucketItem';
	import { IBucketModalProps } from '@core/_interfaces/ComponentProps';
	import StoreRebate from '@core/classes/Store/StoreRebate';

	import EditInfo from '@/components/EditInfo.vue';
	import InputCheckbox from '@core/components/InputCheckbox.vue';
	import InputCurrency from '@core/components/InputCurrency.vue';
	import InputNumber from '@core/components/InputNumber.vue';
	import InputRichDropdown from '@core/components/InputRichDropdown.vue';
	import InputTextbox from '@core/components/InputTextbox.vue';
	import Panel from '@core/components/Panel.vue';

	const { modal } = defineProps<{
		modal: IRebatesBucketModalProps;
	}>();

	const user = auth.getTokenPayload();

	// Copy Buyer's Order
	const bo = ref<FIMenuBuyersOrder>(new FIMenuBuyersOrder(modal.bo));
	const rebate = ref<DealRebate>(null);
	const rebateIndex = ref<number>(null);
	const bucket = ref<FIMenuBuyersOrderBucket>(modal.bucketContent.parentBucket);
	const originalName = ref<string>(null);
	const isNewRebate = ref(false);
	const selectedStoreRebate = ref<StoreRebate>(null);
	const storeRebates = ref<StoreRebate[]>(null);
	const profitFlags = ref(null);
	const ITEMIZED_OPTIONS = [
		{
			value: true,
			display: 'Yes',
		},
		{
			value: false,
			display: 'No',
		},
	];
	const REBATES_TITLE_ID = '10012';

	profitFlags.value = DropdownHelper.getProfitFlags();

	storeRebates.value = modal.storeRebates.map(r => new StoreRebate(r));

	//IF NEW REBATE, CREATE IT AND CREATE A BUCKET FOR IT
	if (!modal.bucketContent.bucketItem) {
		isNewRebate.value = true;
		rebate.value = bo.value.addNewDefaultRebate(modal.bucketContent.parentBucket.titleId, true, true, true, true);
	} else {
		isNewRebate.value = false;

		// Find corresponding bucket in Buyer's Order copy
		bucket.value = bo.value.buckets.find(
			b =>
				b.bucketType === modal.bucketContent.parentBucket.bucketType &&
				b.originalTitleId === modal.bucketContent.parentBucket.originalTitleId &&
				b.titleId === modal.bucketContent.parentBucket.titleId &&
				b.taxIndex === modal.bucketContent.parentBucket.taxIndex &&
				b.upfrontTaxIndex === modal.bucketContent.parentBucket.upfrontTaxIndex,
		);

		rebate.value = bo.value.rebates.find((r: DealRebate) => r.desc == modal.bucketContent.bucketItem.name);
		originalName.value = rebate.value.desc;

		if (!bucket.value) {
			bucket.value = bo.value.addNewDefaultBucket(bucket.value.bucketType, 0, 0, null, rebate.value.titleId, rebate.value.titleId);
		}

		rebateIndex.value = bo.value.rebates.findIndex((r: DealRebate) => r.desc == modal.bucketContent.bucketItem.name);
	}

	// Only tax lines get reset when Buyer's Order is reset
	watch(
		() => bucket.value.taxIndex,
		() => {
			bo.value.isManuallyChanged = true;
		},
	);

	function onStoreRebateSelected() {
		if (!selectedStoreRebate.value) return;

		//REBATE INFO
		rebate.value.clearDescriptionOnSelection = selectedStoreRebate.value.clearDescriptionOnSelection;
		rebate.value.id = selectedStoreRebate.value.id;
		if (!selectedStoreRebate.value.clearDescriptionOnSelection) {
			rebate.value.desc = selectedStoreRebate.value.name;
			rebate.value.code = selectedStoreRebate.value.code;
		} else {
			rebate.value.desc = null;
			rebate.value.code = null;
		}
		rebate.value.amount = selectedStoreRebate.value.amount;
		rebate.value.cost = selectedStoreRebate.value.cost;
		rebate.value.profitFlag = selectedStoreRebate.value.profitFlag;
		// rebate.value.isEditableName = selectedStoreRebate.value.isEditableName;
		rebate.value.isEditableCode = selectedStoreRebate.value.isEditableCode;
		rebate.value.isEditableAmount = selectedStoreRebate.value.isEditableAmount;
		rebate.value.isEditableCost = selectedStoreRebate.value.isEditableCost;
		// rebate.value.isEditableProfitFlag = selectedStoreRebate.value.isEditableProfitFlag;
		// rebate.value.isEditableTitleId = selectedStoreRebate.value.isEditableTitleId;
		rebate.value.isEditableItemized = selectedStoreRebate.value.isEditableItemized;
		rebate.value.matchToFirstPayment = selectedStoreRebate.value.matchToFirstPayment;
		rebate.value.maxAmount = null;
		rebate.value.itemized = rebate.value.isEditableItemized ? false : selectedStoreRebate.value.itemized;
		rebate.value.titleId = selectedStoreRebate.value.titleId;

		//SET UP BUCKET & TITLE ID
		let newBucket = null;
		if (selectedStoreRebate.value.titleId) {
			newBucket = bo.value.buckets.find(
				(b: FIMenuBuyersOrderBucket) => b.bucketType === modal.bucketContent.parentBucket.bucketType && b.titleId == selectedStoreRebate.value.titleId,
			);
		}

		if (!newBucket) {
			newBucket = bo.value.addNewDefaultBucket(bucket.value.bucketType, 0, 0, null, null, selectedStoreRebate.value.titleId);
		}

		bucket.value = newBucket;
	}

	//GIVEN A taxLineIndex RETURNS TRUE IF THE CURRENT ITEM'S IS TAXED ON THAT TAX LINE
	function isInThisTaxLine(taxLineIndex: number) {
		const taxIndex = bo.value.isLease() ? bucket.value.upfrontTaxIndex : bucket.value.taxIndex; //Which tax index? (check if the bucket is upfront)
		const taxBinaryArray = util.taxIndexToBinaryArray(taxIndex);
		const isInThisTaxLine = taxBinaryArray[taxLineIndex] == '1';

		return isInThisTaxLine;
	}
	function toggleTaxLine(taxLineIndex: number) {
		const isSelected = !isInThisTaxLine(taxLineIndex);

		const originalBucketData = new FIMenuBuyersOrderBucket(bucket.value);

		//GET THE NEW TAX INDEX THIS ITEM WILL HAVE AFTER TOGGLE
		const taxBinaryArray = util.taxIndexToBinaryArray(bucket.value.taxIndex);
		taxBinaryArray[taxLineIndex] = isSelected ? '1' : '0';
		const newTaxIndex = util.binaryArrayToTaxIndex(taxBinaryArray);

		//GET THE NEW TAX INDEX THIS ITEM WILL HAVE AFTER TOGGLE
		const upfrontTaxBinaryArray = util.taxIndexToBinaryArray(bucket.value.upfrontTaxIndex);
		upfrontTaxBinaryArray[taxLineIndex] = isSelected ? '1' : '0';
		const newUpfrontTaxIndex = util.binaryArrayToTaxIndex(upfrontTaxBinaryArray);

		//CREATE NEW BUCKET WITH THE NEW TAX INDEX
		bucket.value = bo.value.addNewDefaultBucket(bucket.value.bucketType, newTaxIndex, newUpfrontTaxIndex, originalBucketData, null, bucket.value.originalTitleId);
		rebate.value.titleId = bucket.value.titleId;
	}

	function deleteRebate() {
		const result = confirm('Are you sure you want to delete this rebate?');
		if (result) {
			const foundBucket = bo.value.buckets.find(bucket => bucket.items.some(item => item.name == originalName.value));
			if (!foundBucket) {
				util.toastr('error', 'Buyers Order', 'Could not remove rebate');
				$modal.cancel();
			}

			bo.value.removeRebate(rebateIndex.value);
			bucket.value.removeItem(originalName.value);
			$modal.close(bo.value);
		}
	}
	function close() {
		let item = bucket.value.items.find((i: FIMenuBuyersOrderBucketItem) => i.name == originalName.value);
		if (item) {
			item.name = rebate.value.desc;
			item.amount = rebate.value.amount;
			item.cost = rebate.value.cost;
		} else {
			item = new FIMenuBuyersOrderBucketItem({
				bucketItem: {
					amount: rebate.value.amount,
					cost: rebate.value.cost,
					profitFlag: rebate.value.profitFlag,
					name: rebate.value.desc,
					sign: 1,
					metadata: {
						itemized: rebate.value.itemized,
					},
				},
				parentBucket: bucket.value,
			});

			bucket.value.items.push(item);
		}

		item.profit = rebate.value.amount - rebate.value.cost;

		// Update last edit info
		rebate.value.editedById = user.EmployeeId;
		rebate.value.editedByName = user.EmployeeName;
		rebate.value.lastModifiedAt = new Date();

		if (isNewRebate.value) {
			rebate.value.createdById = user.EmployeeId;
			rebate.value.createdByName = user.EmployeeName;
			rebate.value.createdAt = new Date(rebate.value.lastModifiedAt);
		}

		$modal.close(bo.value);
	}

	function cancel() {
		$modal.cancel();
	}

	const validations = computed(() => ({
		rebate: rebate.value.validation(bo.value) as any,
	}));
	const v$ = useVuelidate(validations, { rebate });
</script>
<style>
	.ModalAddEditRebate .description {
		justify-content: flex-start;
	}

	.ModalAddEditRebate .modal-header .additional-info {
		font-size: 0.75rem;
		color: var(--third-color);
	}
</style>
